import ApiService from '../../../../../services/ApiService'
import Utils from '../../../../../Utils/FormatDate'

export default {
  async created() {
    this.userLogged = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id
    this.updateTable()
  },

  data: () => ({
    loading: false,
    institution: null,
    institutionId: null,
    expanded: [],
    userLogged: {},
    currentCalibrationPattern: {},
    useRequestsApproved: [],
    headers: [
      {
        text: 'Padrão',
        align: 'center',

        value: 'name',
      },
      {
        text: 'Nº Série',
        align: 'center',

        value: 'serialNumber',
      },
      {
        text: 'Instituição Cedente',
        align: 'center',

        value: 'institution',
      },
      {
        text: 'Data Aprovação',
        align: 'center',

        value: 'approvedDate',
      },
      {
        text: 'Ações',

        align: 'center',
        value: 'actions',
        sortable: false,
      },
    ],
    headersMobile: [
      {
        text: 'Padrão',
        align: 'center',

        value: 'name',
      },
    ],
    headerProps: {
      sortByText: 'Ordenar por',
    },
    apiService: new ApiService(),
  }),

  components: {},

  methods: {
    callVisualizeCalibrationPattern(calibrationPattern) {
      this.currentCalibrationPattern = calibrationPattern
      this.$router.push({
        name: 'editCalibrationPattern',
        params: {
          calibrationPatternIdProps: this.currentCalibrationPattern.id,
        },
      })
    },

    uploadDocument(calibrationPattern) {
      sessionStorage.clear()
      this.currentCalibrationPattern = calibrationPattern
      sessionStorage.setItem(
        'calibrationPattern',
        JSON.stringify(this.currentCalibrationPattern)
      )
      this.$router.push({ path: '/uploadDocument' })
    },

    close() {
      this.$router.go(-1)
    },

    async updateTable() {
      this.loading = true

      await this.apiService
        .get(`calibrationPattern/approved/${this.institutionId}`)
        .then((response) => {
          this.useRequestsApproved = response.content
          this.loading = false
        })
    },

    formatDate(date) {
      return Utils.moment(date)
    },
  },

  watch: {},
}
